<template>
  <v-app>
    <component
      v-if="initlizeComponent"
      :is="layout"
    />   
  </v-app>
</template>
<script>
  import Repository from '@/repositories/marketing'
  import { $users } from '@core/services/'
  import Auth from '@/layouts/Auth'
  import Default from '@/layouts/Default'
  import Dashboard from '@/layouts/Dashboard'
  import { mapActions, mapGetters } from 'vuex'
  import { sanitiseAccountList, verifyAccountCluster } from "@core/config/utils";
  import moment from "moment-timezone";
  import { createSplitFactory } from '@/splitClient';
  
  export default {
    name: 'App',
    components: {
      Auth,
      Dashboard,
      Default,
    },
    data () {
      return {
        miniHeader: true,
        railsLocation: '',
        railsData: {},
        page: 1,
        perPage: 10,
        initlizeComponent:false
      }
    },
    computed: {
      ...mapGetters(['allData']),
      ...mapGetters({
        userAccess: "auth/userAccess"
      }),
      layout () {
        return this.$store.getters['ui/layout']
      },
      currentAccount(){
        return this.$store.getters['auth/account'].current
      },
      params: {
        get(){
          return this.$store.getters['auth/account'].pagination
        },
        set(value){
          this.$store.commit('auth/account.pagination', value)
        }
      }
    },
    async mounted () {
      document.getElementById("splash").style.display = "block";
      if ( this.$keycloak && this.$keycloak.authenticated){
        this.$store.commit('auth/setMaropostIdentityToken',this.$keycloak.idToken);
        if(this.currentAccount && this.currentAccount.id && this.checkAccountInURl(this.currentAccount.id)){
          await createSplitFactory(this.currentAccount.id);
          await verifyAccountCluster(this.currentAccount)
          await this.$store.dispatch('auth/getAccountInfo')
          await this.$store.dispatch('auth/getPackageFeatures')
          await this.$store.dispatch('auth/getPreferences')
          if(!this.$store.state.auth.editAccountId){
            await this.$store.dispatch('auth/getRoles')
          }  
          this.$store.dispatch('ui/getNotifications')
          this.initlizeComponent = true;
          document.getElementById("splash").style.display = "none";
         }else{
          await this.fetchUserInfo();
        }
        window.addEventListener('message', this.processMessage, false)
      }else{
        this.initlizeComponent = true;
      }
    },
    methods: {
      ...mapActions({__getAccountInfo: 'auth/getAccountInfo'}),
      checkAccountInURl(accountId){
        if(window.location.pathname.split('/')[2] && window.location.pathname.split('/')[2] == accountId)
          return true
        return false
      },
      getAccountId(){
        if(window.location.pathname.split('/')[2] && !isNaN(parseInt(window.location.pathname.split('/')[2])))
          return parseInt(window.location.pathname.split('/')[2])
        return null;
      },
      axiosErrorHandler(err ,accountId = null){  
        let message = "response" in err && typeof err.response=='object' && "data" in err.response && "errors" in err.response.data && err.response.data.errors;
        
        document.getElementById("splash").style.display = "none";
        this.initlizeComponent = true;

        this.$router.push({name:'select-account',query:{accountId:accountId,message:message}})
      },

      async fetchUserInfo(){
        let THIS = this;
        this.params.page = 1;
        $users.getAllAccountList({
          params: {
            page: this.params.page,
            per_page: this.params.per_page
          }
        }).then(async (AccountsResponse) => {
        /**
         * Check for valid Accounts response
         */
        if(!("data" in AccountsResponse.data)
          || AccountsResponse.data.data == undefined 
          || AccountsResponse.data.data == null  
          || AccountsResponse.data.data.length == 0){

            let url = `${this.$config.MAROPOST_IDENTITY_BASE_URL}/#/dashboard?code=${400}&message=No linked account found for this user. Kindly contact Admin.`;
            window.location.href = url;
          return;
        }

        /**
         *  Set Default default_account Value as null
         *  SanitiseAccountsList for uid.
         */
        let default_account = null;
        let account_list = sanitiseAccountList(AccountsResponse.data.data);
        this.$store.commit('auth/account.list', account_list);
        /**
         * Fetch User Preferences for Default Account
         */
        try{ 
          let identityResponse =  await $users.getPreferences()
          if(!identityResponse.time_zone)
            identityResponse.time_zone = "America/New_York"
          /*** add timezone */
          let timeZoneOffset = moment.tz(identityResponse.time_zone).format('Z');
          // Get the UTC offset in minutes
          let minutesOffset = moment().utcOffset(timeZoneOffset).utcOffset();
          // Convert minutes to hours
          let decimalOffset = minutesOffset / 60;
          identityResponse.timezone_offset = decimalOffset;
          this.$store.commit('auth/setPreferences', identityResponse);
          default_account = identityResponse.default_account_id
        }catch(err){
          default_account = null
        }


        /**
         * check if default account exist in account_list
         * fetch details if not in account_list
         */
        let id = this.$route.params.accountId || this.getAccountId()
        console.log("account id", id)
        let accountId = account_list[0].id

        if(default_account || id){
          accountId = !!parseInt(id) ? id : default_account
          let index = 0;

          if(!!parseInt(id)){
            index = account_list.findIndex(i=>i.id == id)
            if(index==-1){
              let account = await this.VerifyAccount(id);
              if(account){
                account_list.push(account)
                this.$store.commit('auth/account.list', account_list); 
                index = account_list.length - 1
              }
            }
          }
          else
            index = -1;

          if(index < 0 && default_account)
            index = account_list.findIndex(i=>i.id == default_account)
          
          if(index < 0){
            if(default_account){
              let account = await this.VerifyAccount(default_account);
              if(account){
                account_list.push(account)
                this.$store.commit('auth/account.list', account_list); 
              }else{
                accountId = account_list[0].id  
              }
            }else{
              accountId = account_list[0].id  
            }
          }else{
            accountId = account_list[index].id  
          }
        }
        /**
         * Compute/Set BASE_URL for repective Account
         */
        let account = account_list.find(i=>i.id == accountId)
        await createSplitFactory(accountId);
        verifyAccountCluster(account);
        

        try{
          /**  Fetch user roles */  
          let roles = await $users.getRoles({}, account.uid);
          this.userResponseRoles = roles.data.data.roles
          this.$store.commit('auth/roles', this.userResponseRoles)

          /** Fetch Account Package Information and Visible Menus  */
          let response = await $users.getPackageFeatures()
          this.$store.commit("auth/package.features", response.data.data)
        }catch(err){
          this.axiosErrorHandler({
              response: {
                status : 400,
                data: {
                  errors: "Error in fetching account information"
                }
              }
            },accountId)
          return;
        }
        
        /**
         * Fetch Account Info from Marketing.
         */      
        let REDIRECT_URL = {}
        
        if(this.$route.name)
          REDIRECT_URL = {name:this.$route.name,params:{...this.$route.params ,accountId: accountId }, query: this.$route.query}
        else
          REDIRECT_URL ={path:`/accounts/${accountId}/dashboard`}
        if((!account.enable_marketing || !this.userAccess.haveMarketingRole) && (account.enable_service || this.userAccess.haveServiceRole)){
          REDIRECT_URL ={path: `/service/${accountId}/dashboard`}
        }
        this.__getAccountInfo({
          accountId: accountId, 
          successHandler: ()=>{
            THIS.$store.commit('auth/account.id', accountId)
            THIS.$store.commit('auth/account.ids', account.id)
            THIS.$store.dispatch('ui/getNotifications')
            THIS.$store.commit('auth/loggedIn', true)
            THIS.initlizeComponent = true;
            THIS.$router.push(REDIRECT_URL)
            document.getElementById("splash").style.display = "none";     
          },
          errorHandler: (err)=>{
            THIS.axiosErrorHandler({
              response: {
                status : 400,
                data: {
                  errors: "Error in fetching account information"
                }
              }
            },accountId)    
          }
        });

      }).catch(()=>{
        let url = `${this.$config.MAROPOST_IDENTITY_BASE_URL}/#/dashboard?code=${400}&message=Something went wrong.`;
        window.location.href = url;
        return;
      });

    },
    VerifyAccount: async(accountId)=>{
      try{
        let response = await $users.getAllAccountList({
          params: {
            id_eq: accountId
          }
        })
        let {data} = response.data;
        if( data == null || data.length == 0){
          return null
        } else if(data.length){
          data = sanitiseAccountList(data);
          let account = data[0];
          return account;
        }
        
      }catch(err){
        this.axiosErrorHandler(err,accountId)
        return;
      }
    },

      async processMessage (event) {
        const type = event.data.type
        switch (type) {
          case '404':
            this.$router.push({ path: '/404' })
          break
          case 'onEditContent':
            // This is used for closing the iframe while editing the content from campaigns            
            if(event.data.save_content === "true"){
              this.$root.$emit('closeIframeContent')
            }
            break
          case 'saveAndclose':
            // This is used for closing the iframe while editing the content from campaigns
            if(event.data.save_and_close === "true"){
              this.$root.$emit('closeIframeContent')
            }
            break
          case 'railsMessage':
            this.$store.commit('ui/loader.iframe', false)
            const loggedIn = this.$store.getters['auth/loggedIn']
            this.$store.commit('auth/iframe.document', event.data.document)
            // this.$store.commit('auth/token', event.data.sessionToken)
            // this.$store.commit('auth/account.list', JSON.parse(event.data.account_list))
            // this.$store.commit('auth/userIndustry', JSON.parse(event.data.default_account)?JSON.parse(event.data.default_account).industry:"UNKNOWN")
            //  this.$store.commit('auth/defaultAccount', JSON.parse(event.data.default_account)?JSON.parse(event.data.default_account).name:"UNKNOWN")
            // this.$store.commit('auth/userdata', JSON.parse(event.data.user))  
            let titleLength = event.data.document.title.split(')').length - 1
            if(this.$store.getters['ui/notifications'].unread  ){
                document.title = '(' + this.$store.getters['ui/notifications'].unread.toLocaleString() + ') ' + event.data.document.title.split(')')[titleLength] 
            } else {
                document.title = event.data.document.title.split(')')[titleLength]
            }
            if(event.data.accountId)
              this.$store.commit('auth/account.id', event.data.accountId)

            this.$store.dispatch('auth/getRoles')
            this.$store.dispatch('ui/getNotifications')
            this.$store.dispatch('auth/getPackageFeatures')
            if (!loggedIn) {
              let accountId
              const userDetails = JSON.parse(event.data.user)
              const userAccounts = JSON.parse(event.data.account_list)
             
             if(userDetails && userDetails.default_account_id){
                accountId = userDetails.default_account_id
                this.$store.commit('auth/account.id', accountId)
              }else if(userAccounts && userAccounts.length > 0){
                accountId = userAccounts[0].id
              }
                         
              Repository.defaults.baseURL = this.$config.RAILS_BASE_URL + '/v2/' + accountId
              this.$store.commit('auth/loggedIn', true)
              this.$router.push({
                path:
                  '/accounts/' + accountId + '/dashboard',
              })
            } else {
              const document = event.data.document
              const allowed_methods = ['GET']

              if (typeof document.has_error === 'string') {
                document.has_error = document.has_error === 'true'
              } else if (typeof document.has_error !== 'boolean') {
                document.has_error = false
              }
              if (!document.has_error && (
                !document.method ||
                allowed_methods.includes(document.method.toUpperCase())
              )
              ) {
                let railsLocation = document.href
                let urlObj = new URL(railsLocation);
                urlObj.searchParams.delete('token');
                urlObj.searchParams.delete('MP-ID-TOKEN');
                urlObj.searchParams.delete('TZ');
                railsLocation = urlObj.toString()
                const path = railsLocation.replace(this.$config.RAILS_BASE_URL, '')
                if (path !== this.$route.fullPath) {
                  /*** Redirect to Journey Flow */
                  if(this.$store.getters['journey/returnFromContent']){
                    this.$router.push({
                      path:"/accounts/"+this.$store.getters["auth/account"].id+"/journeys/new/template"
                    })
                  }
                  else if(!this.$route.meta.restrictIframe){
                    this.$router.push({ path: path })
                  }
                }
              }
            }
          break;
          case 'window.alert':
            alert(event.data.message)
          break
          case "window.confirm":
            let result = confirm(event.data.message);
            const frame = document.getElementById("legacyMainIframe").contentWindow;
            frame.postMessage({
                type: "window.confirm",
                result: result
            },"*");
          break;
          case 'contactOverview':
            this.$router.push({
              path:
                '/accounts/' +
                event.data.accountId +
                '/lists/' +
                event.data.listId +
                '/contacts/' +
                event.data.contactId,
            })
            break
          case 'newContentCampaign':
            this.$store.state.campaign.type = '';
            this.$store.commit('campaign/setCampaignId', null)
            var href = event.data ? event.data.href : undefined;
            if(href){
              this.$router.push({
                path: href
              })
            }
            break
          case 'loggedOut':
            this.$store.dispatch('auth/logout')
            break
          case 'a.click':
            event.data.href = event.data.href.replace(this.$config.RAILS_BASE_URL, '')
            var RgExp = new RegExp('^(?:[a-z]+:)?//', 'i')
            if (RgExp.test(event.data.href)) {
              if (event.data.target) {
                window.open(event.data.href, '_blank')
              } else {
                this.$router.push({ path: '/external', query: { href: event.data.href } })
              }
            } else {
              if (event.data.href.includes('social_accounts/auth')) {
                window.open(this.$config.RAILS_BASE_URL + event.data.href, '_blank')
              } else if (this.$route.fullPath === event.data.href) {
                if (event.data.target) {
                  window.open(this.$config.RAILS_BASE_URL + event.data.href, '_blank')
                } else {
                  this.$store.commit('ui/iframe.url', this.$config.RAILS_BASE_URL)
                }
                this.$nextTick(() => {
                  if (event.data.target) {
                    window.open(this.$config.RAILS_BASE_URL + event.data.href, '_blank')
                  } else {
                    this.$store.commit('ui/iframe.url', this.$config.RAILS_BASE_URL + event.data.href)
                  }
                })
              } else {
                if (event.data.target) {
                  window.open(this.$config.RAILS_BASE_URL + event.data.href, '_blank')
                } else {
                    if(event.data.has_view.split(' ').includes('no_view_link')) {
                     this.$store.commit('ui/iframe.url', this.$config.RAILS_BASE_URL + event.data.href)
                  }
                  else{
                    this.$router.push({ path: event.data.href })
                  }
                }
              }
            }
        }
      },
      ...mapActions(['fetchData']),
    },
  }
</script>

<style lang="scss">
html {
  overflow: auto;
}

$primary-font-size: 13px !important;
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  box-shadow: 0 0 0 30px white inset !important;
  -webkit-box-shadow: 0 0 0 30px white inset !important;
}
.vertical-stretch .list-background{
  background-color:#fff;
}
.vertical-stretch {
  height: calc(100vh - 64px) !important;
  overflow: auto;
}
.background-white .v-list-item:hover {
  background-color: rgb(244,244,244) !important;
}
.background-white .v-list-item--active::before {
  background-color: #ffffff !important;
}
.v-application,
.primary--font {
  font-family: "Roboto", sans-serif !important;
}
.background-white .v-list-item:hover {
  background-color: rgb(244,244,244) !important;
}
.background-white .v-list-item--active::before {
  background-color: #ffffff !important;
}
.seconday--font,
h1,
h2,
h3,
h4,
h5,
h6,
.v-btn {
  font-family: "Montserrat", sans-serif !important;
}
.secondary--font{
  font-family: "Montserrat", sans-serif !important;
}
body {
  font-size: 16px;
  letter-spacing: 0.5px;
}
.v-btn--text {
  font-weight: 600 !important;
  letter-spacing: 0.55px;
  font-size: $primary-font-size;
}
.v-btn {
  font-weight: bold;
}
.v-application .mp-secondary--text {
  color: #4c5463 !important;
  caret-color: #4c5463 !important;
}
.footer-chat {
  position: fixed;
  bottom: 20px;
  right: 35px;
  animation: 1s linear chat-widget;
  cursor: pointer;
}
.custom-chat-widget {
  background-color: #03b6fc;
  border-radius: 5px;
}
.popup-title {
  color: #03b6fc !important;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 600 !important;
}
@keyframes chat-widget {
  0% {
    bottom: 0px;
  }
  100% {
    bottom: 20px;
  }
}
.v-overflow-btn {
  .v-input__control::before {
    height: 0px !important;
  }
  .v-list-item__title,
  .v-list-item__subtitle {
    white-space: normal !important;
  }
  .v-input__append-inner {
    width: 25px !important;
  }
  .v-select__selection--comma:first-child {
    margin-left: 8px !important;
  }
  .v-input__append-inner {
    margin-top: 2px !important;
  }
}
.text-decoration-none {
  text-decoration: none;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.7s
}

.fade-enter, .fade-leave-active {
  opacity: 0
}

/*** Multiple Drag Drop Styles */
.multi-drag-drop-wrapper{
  .select-all:hover{
    opacity: 1 !important;
  }
  .selected-text{
    text-decoration: underline;
    text-transform: lowercase;
    font-size: 14px;
    font-family: "Roboto", sans-serif !important;
  }
}
</style>
